// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.community-select-container {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
}

.community-select-display {
  flex: 1 1;
  padding: 12px 16px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.community-select-display:hover,
.community-select-display:focus {
  border-color: var(--primary-color);
}

.community-select-display .arrow {
  margin-left: 8px;
  font-size: 12px;
}

.community-info-icon {
  margin-left: 8px;
  cursor: pointer;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
}
.community-info-icon.disabled {
  opacity: 0.4;
  cursor: default;
  border:none;
}
.community-info-icon:not(.disabled):hover {
  color: var(--text-primary);
}
.community-info-icon svg {
  display: block;
}

.community-info-modal {
  background: var(--card-bg);
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}
.community-info-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border-color);
}
.community-info-modal .modal-header h2 {
  margin: 0;
  font-size: 18px;
}
.community-info-modal .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--text-primary);
}
.community-info-modal .modal-content {
  padding: 16px 24px;
}

/* backdrop style in case not imported elsewhere */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.community-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  margin-top: 4px;
  z-index: 1000;
  max-height: 300px;
  display: flex;
  flex-direction: column;
}

.community-filter {
  padding: 8px 12px;
  border: none;
  border-bottom: 1px solid var(--border-color);
  font-size: 14px;
  outline: none;
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.community-options {
  overflow-y: auto;
}

.community-option {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  color: var(--text-primary);
}

.community-option:hover,
.community-option.selected {
  background: var(--hover-bg);
}

.community-option.empty {
  text-align: center;
  color: var(--text-secondary);
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/components/CommunitySelect/CommunitySelect.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,4CAA4C;EAC5C,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB","sourcesContent":[".community-select-container {\r\n  position: relative;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.community-select-display {\r\n  flex: 1;\r\n  padding: 12px 16px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  background: var(--bg-secondary);\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.community-select-display:hover,\r\n.community-select-display:focus {\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n.community-select-display .arrow {\r\n  margin-left: 8px;\r\n  font-size: 12px;\r\n}\r\n\r\n.community-info-icon {\r\n  margin-left: 8px;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.community-info-icon.disabled {\r\n  opacity: 0.4;\r\n  cursor: default;\r\n  border:none;\r\n}\r\n.community-info-icon:not(.disabled):hover {\r\n  color: var(--text-primary);\r\n}\r\n.community-info-icon svg {\r\n  display: block;\r\n}\r\n\r\n.community-info-modal {\r\n  background: var(--card-bg);\r\n  border-radius: 12px;\r\n  width: 100%;\r\n  max-width: 500px;\r\n  max-height: 80vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.community-info-modal .modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 16px 24px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n.community-info-modal .modal-header h2 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n}\r\n.community-info-modal .close-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  color: var(--text-primary);\r\n}\r\n.community-info-modal .modal-content {\r\n  padding: 16px 24px;\r\n}\r\n\r\n/* backdrop style in case not imported elsewhere */\r\n.modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 20px;\r\n}\r\n\r\n.community-dropdown {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  right: 0;\r\n  background: var(--card-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  margin-top: 4px;\r\n  z-index: 1000;\r\n  max-height: 300px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.community-filter {\r\n  padding: 8px 12px;\r\n  border: none;\r\n  border-bottom: 1px solid var(--border-color);\r\n  font-size: 14px;\r\n  outline: none;\r\n  background: var(--bg-secondary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.community-options {\r\n  overflow-y: auto;\r\n}\r\n\r\n.community-option {\r\n  padding: 8px 12px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.community-option:hover,\r\n.community-option.selected {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.community-option.empty {\r\n  text-align: center;\r\n  color: var(--text-secondary);\r\n  cursor: default;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
